import React, { useCallback, useState } from 'react'

interface IMultiLineInputProps {
  defaultValue?: string
  placeholder?: string
  maxLength?: number
  onChange: (value: string) => void
  onEntered?: (value: string) => void
}

const MultiLineInput: React.FC<IMultiLineInputProps> = ({
  defaultValue,
  placeholder,
  maxLength,
  onChange,
  onEntered,
}) => {
  const [value, setValue] = useState<string>(defaultValue || '')

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange(event.target.value)
      setValue(event.target.value)
    },
    [onChange]
  )

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (onEntered && event.key === 'Enter') onEntered(value)
    },
    [onEntered, value]
  )

  const handleBlur = useCallback(() => {
    if (onEntered) onEntered(value)
  }, [onEntered, value])

  return (
    <textarea
      value={value}
      className='form-control'
      maxLength={maxLength}
      rows={3}
      placeholder={placeholder}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
    />
    // <Form.Control
    //   value={value}
    //   type='textarea'
    //   placeholder={placeholder}
    //   maxLength={maxLength}
    //   onChange={handleChange}
    //   onKeyDown={handleKeyDown}
    //   onBlur={handleBlur}
    // />
  )
}
export default MultiLineInput
